/* Qalbeen · HOVER : petits comportements de l'accueil (sections hover-home-*). Sans jQuery, chargé en defer.
   - onglets [data-hvh-tabs] : puces qui montrent un panneau [data-hvh-panel] (Par où commencer, FAQ)
   - vidéos [data-hvh-vid] : la vidéo n'est chargée qu'au toucher du bouton lecture
   - chiffres [data-hvh-count] : comptent jusqu'à la valeur affichée (déjà écrite par Liquid, aucun saut)
   - échelle des cadeaux [data-hvh-band] et photos qui défilent [data-hvh-marquee]
   - bouton [data-hvh-chat] : ouvre le chat Crisp s'il est là, sinon suit le lien
   - liens [data-hvh-avis] : ouvrent la fenêtre des avis [data-hvh-dlg] (section Avis), avis Vitals lus en direct
   - liens internes « #… » de l'accueil (ex. #commencer) : défilement doux sous l'en-tête */
(function () {
  if (window.HoverHome) return;
  var D = document;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); };

  D.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-hvh-tab]');
    if (t) {
      var box = t.closest('[data-hvh-tabs]'); if (!box) return;
      var k = t.getAttribute('data-hvh-tab');
      $$('[data-hvh-tab]', box).forEach(function (b) { var on = b === t; b.setAttribute('aria-pressed', on); b.setAttribute('aria-selected', on); });
      $$('[data-hvh-panel]', box).forEach(function (p) {
        var on = p.getAttribute('data-hvh-panel') === k; p.hidden = !on;
        if (on) { var r = p.querySelector('.hv-rail'); if (r) r.scrollLeft = 0; }
      });
      return;
    }
    var v = e.target.closest && e.target.closest('[data-hvh-play]');
    if (v) {
      var card = v.closest('[data-hvh-vid]'), tpl = card && card.querySelector('template'), ph = card && card.querySelector('.hvh-vid__ph');
      if (!tpl || !ph) return;
      e.preventDefault();
      $$('[data-hvh-vid].on video').forEach(function (o) { o.pause(); });
      var old = ph.querySelector('video');
      if (!old) { ph.appendChild(tpl.content.cloneNode(true)); old = ph.querySelector('video'); }
      card.classList.add('on');
      if (old) { old.setAttribute('playsinline', ''); var p = old.play(); if (p && p.catch) p.catch(function () { old.muted = true; old.play().catch(function () {}); }); }
      return;
    }
    var c = e.target.closest && e.target.closest('[data-hvh-chat]');
    if (c && window.$crisp && window.$crisp.push) {
      e.preventDefault();
      window.$crisp.push(['do', 'chat:show']); window.$crisp.push(['do', 'chat:open']);
    }
  });

  /* liens internes (#commencer…) de l'accueil seulement : défilement doux, sous l'en-tête collant */
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('main a[href^="#"]'); if (!a || e.defaultPrevented || !D.querySelector('.hvh-hero')) return;
    var h = a.getAttribute('href'); if (h.length < 2) return;
    var t = D.getElementById(decodeURIComponent(h.slice(1))); if (!t) return;
    e.preventDefault();
    var hd = parseInt(getComputedStyle(D.documentElement).getPropertyValue('--hv-hd-h'), 10) || 64;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - hd - 8, behavior: reduce ? 'auto' : 'smooth' });
    if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
    try { t.focus({ preventScroll: true }); } catch (x) {}
  });

  /* ---------- fenêtre des avis ----------
     [data-hvh-avis] ouvre le <dialog data-hvh-dlg> de la section Avis (sinon le lien mène à la page des avis).
     À la 1re ouverture, les avis publiés par Vitals sont lus en direct (mêmes fichiers que la page /a/page/top-reviews,
     cf. assets/hover-avis.js) et ajoutés après ceux de l'accueil, 10 par 10. Si Vitals ne répond pas : rien de plus. */
  var dlgVitals = null;
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function etoiles(n) {
    var h = ''; for (var i = 1; i <= 5; i++) h += '<i class="' + (n >= i - 0.25 ? 'on' : n >= i - 0.75 ? 'half' : '') + '"><svg aria-hidden="true"><use href="#hv-i-star"/></svg></i>';
    return '<span class="hv-tp hv-tp--xs" role="img" aria-label="' + String(n).replace('.', ',') + '/5">' + h + '</span>';
  }
  function vitals(dlg) {
    if (dlgVitals) return; dlgVitals = { tous: [], vus: 0, prods: {} };
    var live = dlg.querySelector('[data-hvh-dlg-live]'), more = dlg.querySelector('[data-hvh-dlg-more]');
    var data = window.vtlsLiquidData, keys = data && data.cacheKeys, SHOP = dlg.getAttribute('data-shop');
    var ROOT = (dlg.getAttribute('data-root') || '/').replace(/\/?$/, '/'), T = {};
    try { T = JSON.parse(dlg.querySelector('[data-hvh-dlg-txt]').textContent); } catch (x) {}
    if (!live || !SHOP || !keys || !keys[0]) return;
    var base = 'https://appsolve.io/bundle/api/v2/sf/', lang = (dlg.getAttribute('data-lang') || 'fr').slice(0, 2);
    var lire = function (u) { return fetch(u, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); }); };
    var court = function (t) { return String(t || '').split(' (')[0].replace(/^NOUVEAUT[ÉE]\s*:\s*/i, '').replace(/^x\d+\s+/i, '').split(' : ')[0].trim(); };
    var date = function (d) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || ''); if (!m) return ''; try { return new Date(+m[1], +m[2] - 1, +m[3]).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }); } catch (x) { return ''; } };
    var photo = function (r, k) { return 'https://cdn-pri.vitals.app/phrev/' + SHOP + '/640/' + r.id + '-' + String(k).replace(/^vitals\./, '') + '.jpg'; };
    function carte(r) {
      var p = dlgVitals.prods[r.productId], ph = (r.photos && r.photos.length ? r.photos : (r.imgUrl ? [r.imgUrl] : [])).slice(0, 3), d = date(r.date);
      return '<figure class="hvh-dlg__rev"><div class="hvh-dlg__meta">' + etoiles(+r.stars || 5) + (d ? '<time datetime="' + esc(r.date) + '">' + esc(d) + '</time>' : '') + '</div>' +
        (ph.length ? '<div class="hvh-dlg__ph">' + ph.map(function (k) { return '<img src="' + esc(photo(r, k)) + '" alt="" loading="lazy" decoding="async" onerror="this.remove()">'; }).join('') + '</div>' : '') +
        (r.review ? '<blockquote>« ' + esc(String(r.review).trim()) + ' »</blockquote>' : '') +
        '<figcaption><span>' + esc(String(r.name || '').trim() || '—') + (r.verified ? ' · ' + esc(T.verified || 'Avis vérifié') : '') + '</span>' +
        (p ? '<a href="' + esc(ROOT + 'products/' + p.handle) + '">' + esc(p.nom) + '</a>' : '') + '</figcaption></figure>';
    }
    function afficher() {
      var l = dlgVitals.tous, n = Math.min(l.length, dlgVitals.vus + 10);
      live.insertAdjacentHTML('beforeend', l.slice(dlgVitals.vus, n).map(carte).join(''));
      dlgVitals.vus = n; more.hidden = n >= l.length;
    }
    more.addEventListener('click', afficher);
    lire(base + 'pr/' + lang + '/' + keys[0] + '/p1/' + SHOP + '.json').catch(function () { lang = 'fr'; return lire(base + 'pr/fr/' + keys[0] + '/p1/' + SHOP + '.json'); }).then(function (p1) {
      var nb = Math.min(5, (p1.pg && +p1.pg.tp) || 1), suites = [];
      for (var n = 2; n <= nb; n++) suites.push(lire(base + 'pr/' + lang + '/' + keys[0] + '/p' + n + '/' + SHOP + '.json').then(function (j) { return j.reviews || []; }).catch(function () { return []; }));
      var prs = keys[4] ? lire(base + 'prs/' + SHOP + '/' + lang + '/' + keys[4] + '.json').catch(function () { return null; }) : Promise.resolve(null);
      return Promise.all([Promise.all(suites), prs]).then(function (x) {
        var ps = x[1] && x[1].products_stars;
        if (ps) Object.keys(ps).forEach(function (h) { var v = ps[h]; if (v && v.i) dlgVitals.prods[v.i] = { handle: h, nom: court(v.t) || h }; });
        dlgVitals.tous = (p1.reviews || []).concat.apply(p1.reviews || [], x[0]).filter(function (r) { return r && r.review && String(r.review).trim().length > 2; });
        afficher();
      });
    }).catch(function () {});
  }
  function ouvrirAvis(dlg) {
    if (!dlg || typeof dlg.showModal !== 'function') return false;
    if (!dlg._hvh) {
      dlg._hvh = 1;
      dlg.addEventListener('click', function (e) { if (e.target === dlg || (e.target.closest && e.target.closest('[data-hvh-dlg-x]'))) dlg.close(); });
      dlg.addEventListener('close', function () { D.documentElement.classList.remove('hvh-dlg-on'); });
    }
    if (dlg.open) return true;
    D.documentElement.classList.add('hvh-dlg-on');
    dlg.showModal();
    var b = dlg.querySelector('.hvh-dlg__b'); if (b) b.scrollTop = 0;
    vitals(dlg);
    return true;
  }
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-hvh-avis]'); if (!a) return;
    if (ouvrirAvis(D.querySelector('[data-hvh-dlg]'))) e.preventDefault();
  });

  /* clavier sur les onglets : flèches gauche / droite */
  D.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('[data-hvh-tab]'); if (!t || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var l = $$('[data-hvh-tab]', t.parentNode), i = l.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
    var n = l[(i + l.length) % l.length]; n.focus(); n.click(); e.preventDefault();
  });

  /* chiffres qui comptent : seulement la partie numérique, le texte final reste celui de Liquid */
  function compter(el) {
    var fin = el.textContent, m = fin.match(/\d[\d\s  .,]*/); if (!m) return;
    var brut = m[0].replace(/[\s  ]/g, ''), dec = /[.,]\d+$/.test(brut);
    if (dec) return; // ex. 4,9 : on n'anime pas
    var cible = parseInt(brut.replace(/[.,]/g, ''), 10); if (!cible || cible < 10) return;
    var sep = /[\s  .,]/.test(m[0].trim()) ? ' ' : '';
    var avant = fin.slice(0, m.index), apres = fin.slice(m.index + m[0].trimEnd().length), t0 = null, d = 1400;
    function fmt(n) { var s = String(n); return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : s; }
    function pas(ts) {
      if (!t0) t0 = ts; var x = Math.min(1, (ts - t0) / d), e2 = 1 - Math.pow(1 - x, 3);
      el.textContent = avant + fmt(Math.round(cible * e2)) + apres;
      if (x < 1) requestAnimationFrame(pas); else el.textContent = fin;
    }
    requestAnimationFrame(pas);
  }
  function chiffres(c) {
    if (reduce || (window.Shopify && Shopify.designMode) || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); compter(e.target); } });
    }, { rootMargin: '0px 0px -15% 0px' });
    $$('[data-hvh-count]', c).forEach(function (el) { if (!el._hvh) { el._hvh = 1; io.observe(el); } });
  }

  /* échelle des cadeaux [data-hvh-band] : la ligne dorée se remplit une fois, à l'arrivée à l'écran */
  function paliers(c) {
    var l = $$('[data-hvh-band]', c);
    if (!l.length) return;
    if (reduce || (window.Shopify && Shopify.designMode) || !('IntersectionObserver' in window)) { l.forEach(function (b) { b.classList.add('vu'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); e.target.classList.add('vu'); } });
    }, { threshold: .35 });
    l.forEach(function (b) { io.observe(b); });
  }

  /* photos des clientes [data-hvh-marquee] : pause au toucher (le survol et le clavier sont gérés en CSS) */
  function defile(c) {
    $$('[data-hvh-marquee]', c).forEach(function (m) {
      if (m._hvh) return; m._hvh = 1; var t;
      m.addEventListener('touchstart', function () { clearTimeout(t); m.classList.add('pause'); }, { passive: true });
      m.addEventListener('touchend', function () { clearTimeout(t); t = setTimeout(function () { m.classList.remove('pause'); }, 1800); }, { passive: true });
    });
  }

  function init(c) { chiffres(c); paliers(c); defile(c); }
  window.HoverHome = { init: init };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { init(D); }); else init(D);
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* éditeur : sélectionner un bloc « Choix » ou « Onglet » affiche son panneau */
  D.addEventListener('shopify:block:select', function (e) {
    var b = e.target.closest && e.target.closest('[data-hvh-tab]'); if (b) b.click();
  });
})();
